"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
/* eslint-disable @typescript-eslint/no-explicit-any */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
var coininfo_1 = __importDefault(require("coininfo"));
var crypto = __importStar(require("./index"));
function cryptoFactory(currency) {
    var res;
    switch (currency) {
        case "bitcoin": {
            var network = coininfo_1["default"].bitcoin.main.toBitcoinJS();
            res = new crypto.Bitcoin({ network: network });
            break;
        }
        case "bitcoin_cash": {
            var network = coininfo_1["default"].bitcoincash.main.toBitcoinJS();
            res = new crypto.BitcoinCash({ network: network });
            break;
        }
        case "litecoin": {
            var network = coininfo_1["default"].litecoin.main.toBitcoinJS();
            res = new crypto.Litecoin({ network: network });
            break;
        }
        case "dash": {
            var network = coininfo_1["default"].dash.main.toBitcoinJS();
            res = new crypto.Dash({ network: network });
            break;
        }
        case "qtum": {
            var network = coininfo_1["default"].qtum.main.toBitcoinJS();
            res = new crypto.Qtum({ network: network });
            break;
        }
        case "zcash": {
            var network = coininfo_1["default"].zcash.main.toBitcoinJS();
            res = new crypto.Zec({ network: network });
            break;
        }
        case "bitcoin_gold": {
            var network = coininfo_1["default"]["bitcoin gold"].main.toBitcoinJS();
            res = new crypto.BitcoinGold({ network: network });
            break;
        }
        case "dogecoin": {
            var network = coininfo_1["default"].dogecoin.main.toBitcoinJS();
            res = new crypto.Doge({ network: network });
            break;
        }
        case "digibyte": {
            var network = coininfo_1["default"].digibyte.main.toBitcoinJS();
            res = new crypto.Digibyte({ network: network });
            break;
        }
        case "komodo": {
            var network = coininfo_1["default"].bitcoin.main.toBitcoinJS();
            res = new crypto.Komodo({ network: network });
            break;
        }
        case "pivx": {
            var network = coininfo_1["default"].bitcoin.main.toBitcoinJS();
            res = new crypto.Pivx({ network: network });
            break;
        }
        case "zencash": {
            var network = coininfo_1["default"].zcash.main.toBitcoinJS();
            res = new crypto.Zen({ network: network });
            break;
        }
        case "vertcoin": {
            var network = coininfo_1["default"].vertcoin.main.toBitcoinJS();
            res = new crypto.Vertcoin({ network: network });
            break;
        }
        case "peercoin": {
            var network = coininfo_1["default"].peercoin.main.toBitcoinJS();
            res = new crypto.Peercoin({ network: network });
            break;
        }
        case "viacoin": {
            var network = coininfo_1["default"].viacoin.main.toBitcoinJS();
            res = new crypto.ViaCoin({ network: network });
            break;
        }
        case "stakenet": {
            var network = coininfo_1["default"].bitcoin.main.toBitcoinJS();
            res = new crypto.Stakenet({ network: network });
            break;
        }
        case "stealthcoin": {
            var network = coininfo_1["default"].bitcoin.main.toBitcoinJS();
            res = new crypto.Stealth({ network: network });
            break;
        }
        case "bitcoin_testnet": {
            var network = coininfo_1["default"].bitcoin.test.toBitcoinJS();
            res = new crypto.Bitcoin({ network: network });
            break;
        }
        case "decred": {
            var network = coininfo_1["default"].decred.main.toBitcoinJS();
            res = new crypto.Decred({ network: network });
            break;
        }
        default: {
            throw new Error("Currency ".concat(currency, " doesn't exist!"));
        }
    }
    return res;
}
exports["default"] = cryptoFactory;
//# sourceMappingURL=factory.js.map